var collapsibleListStyles = {"ltr":"d1NPs","rtl":"Xw0F2","iconContainer":"YlEg9","icon":"KICCS","isExpanded":"xj9MV","listDimensions":"Gkw-B"};

export { collapsibleListStyles as c };
